import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { JoinRequestService } from '../../../../../app/shared/API-Service/services/join-request.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
@Component({
  selector: 'app-employment-request-list',
  templateUrl: './employment-request-list.component.html',
  styleUrls: ['./employment-request-list.component.css']
})
export class EmploymentRequestListComponent extends BaseComponent implements OnInit {
  EmploymentRequest:object [] = [];
  img : string = Image;
  constructor(private _JoinRequestService:JoinRequestService,private _Router:Router,
    private _FormBuilder:FormBuilder) {super() }
    pageChanged(event: any){
      this.pageNumber = event.page;// -1 * pageSize;
      this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
      this.getEmploymentRequest()
  
    }
    ngOnInit(): void {
      this.getEmploymentRequest();
    }
    getEmploymentRequest(){
   
      this._JoinRequestService.GetEmploymentRequest(this.pager).subscribe((res) => {
        this.EmploymentRequest = res.data.items
        this.totalCount=res.data.totalCount;
              console.log(this.EmploymentRequest);
      
      },(err)=>{
        console.log('their is a problem');
      },() =>{
        console.log('Completed');
      });
    }
  
    update(data){
      this._JoinRequestService.Data.next(data);
      this._Router.navigate(['/content/admin/InsertJoinRequest']);
      }
  
      delete(id : number){
        Swal.fire({
          title: 'هل تريد مسح العنصر ؟',
          text: "لن يكون لك صلاحية إعادته مره اخرى",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'الغاء',
          confirmButtonText: 'امسح العنصر !'
        }).then((result) => {
          if (result.isConfirmed) {
            this._JoinRequestService.DeleteJoinRequest(id).subscribe((res) => {
              Swal.fire({
                icon: "success",
                title: "تم المسح بنجاح",
                showConfirmButton: false,
                timer: 1500,
              });
           this.getEmploymentRequest();
            },(err) => {
              Swal.fire({
                icon: 'error',
                title: 'خطأ',
                text:err.error.message    
              })
            },() => {
              console.log("completed");
            })
          }
        }) 
      }
}
